import portfolio from './publicPortfolio.cjs';

export const { PUBLIC_PROFILE, PUBLIC_PROJECTS } = portfolio;
